export default "__VITE_ASSET__LQ6n$Ols__"